import * as yup from 'yup';

const scalingPolicySchema = yup
  .object({
    value: yup
      .number()
      .nullable()
      .required('Required')
      .integer('Must be an integer')
      .min(1, 'Must be at least 1'),
    periodSeconds: yup
      .number()
      .nullable()
      .required('Required')
      .integer('Must be an integer')
      .min(1, 'Must be at least 1')
      .max(1800, 'Must be less than or equal to 1800'),
  })
  .nullable()
  .default(null);

const scaleDirectionSchema = yup.object({
  stabilizationWindowSeconds: yup
    .number()
    .required('Required')
    .nullable()
    .integer('Must be an integer')
    .min(0, 'Must be greater than or equal to 0')
    .max(3600, 'Must be less than or equal to 3600'),
  pods: scalingPolicySchema,
  percent: scalingPolicySchema,
});

export const autoscalerBehaviorValidationSchema = yup.object({
  scaleUp: scaleDirectionSchema.required(),
  scaleDown: scaleDirectionSchema.required(),
});
